import { render, staticRenderFns } from "./DesktopMenuItemChild.vue?vue&type=template&id=cd1be31a"
import script from "./DesktopMenuItemChild.vue?vue&type=script&lang=js"
export * from "./DesktopMenuItemChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports